"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var baseRoute = '/settings-service';
exports.Routes = {
    AllTiers: "".concat(baseRoute, "/tiers"),
    AllAccelerators: "".concat(baseRoute, "/accelerators"),
    MerchantTier: "".concat(baseRoute, "/merchant/tier"),
    MerchantAccelerators: "".concat(baseRoute, "/merchant/accelerators")
};
//# sourceMappingURL=Addons.consts.js.map